var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.children
    ? _c(
        "ul",
        { staticClass: "submenu" },
        _vm._l(_vm.children, function(link) {
          return _c(
            "li",
            {
              key: link.slug,
              staticClass: "relative submenu-item",
              class: {
                "with-submenu": link.children_data && link.children_data.length
              },
              on: {
                mouseenter: function($event) {
                  _vm.activeSubMenu = link.id
                },
                mouseleave: function($event) {
                  _vm.activeSubMenu = null
                }
              }
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "menu-link",
                  class: { active: _vm.activeSubMenu == link.id },
                  attrs: {
                    to: _vm.localizedRoute({
                      name: "category",
                      params: { id: link.id, slug: link.url_path }
                    })
                  }
                },
                [_vm._v("\n      " + _vm._s(link.name) + "\n    ")]
              ),
              _vm._v(" "),
              link.children_count > 0
                ? _c("sub-category", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeSubMenu === link.id,
                        expression: "activeSubMenu === link.id"
                      }
                    ],
                    attrs: {
                      "category-links": link.children_data,
                      id: link.id,
                      "parent-slug": link.slug,
                      "parent-name": link.name
                    }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }